import type { FeatureWebModule } from '../../modules/core/index.js'
import { AdminClientInsightsLine } from './components/AdminClientInsightsLine.js'
import { InsightsPage } from './components/InsightsPage.js'
import { INSIGHTS_HELP_TOPICS } from './help.js'
import { FEATURE_KEY, FEATURE_NAME, PAGE_SEGMENT } from './labels.js'

/**
 * The Executive Insights add-on's screens (docs/plans/executive-insights-plan.md
 * section 6): one page of the client's, above the facility picker, listed in
 * the operator shell's bar after Reporting while the client is licensed. It
 * contributes nothing per facility or per worker; the admin's client detail
 * gets one line from its mirror on the API.
 */
export const executiveInsightsWebModule: FeatureWebModule = {
  key: FEATURE_KEY,
  name: FEATURE_NAME,
  operatorPage: { segment: PAGE_SEGMENT, label: 'Insights', icon: 'insights', page: InsightsPage },
  adminClientSection: { heading: 'Executive Insights', section: AdminClientInsightsLine },
  helpTopics: INSIGHTS_HELP_TOPICS,
}
